<template>
  <header class="full-page-header">
    <div
      class="container-fluid h-100 d-flex align-items-center"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      <div
        class="row text-center justify-content-center align-items-center w-100"
      >
        <div class="col-lg-12 px-lg-0">
          <div class="header-img-container">
            <!-- <img
              src="../../assets/images/new_design_v6/Header.png"
              class="header-img img-fluid"
            /> -->
            <picture>
              <source
                media="(max-width: 1480px)"
                srcset="../../assets/images/new_design_v6/Header2.png"
              />
              <img
                src="../../assets/images/new_design_v6/Header.png"
                class="header-img img-fluid"
              />
            </picture>
          </div>

          <!-- <div class="position-relative text-white w-100 mt-3"> -->
          <!-- <div class="d-flex justify-content-center">
              <button
                type="button"
                class="header-btn text-white text-uppercase"
                data-bs-dismiss="modal"
                @click="goToApply"
              >
                Apply Na!
              </button>
            </div> -->
          <!-- <p
              class="header-terms fw-500 text-lg-end text-center pt-5 pt-lg-0 mb-0"
            >
              Terms and Conditions apply. <br />
              Promo Period:
              <span class="fw-semibold"
                >October 20, 2025 to December 31, 2025</span
              ><br />
              Per DTI Fair Trade Permit No. FTEB-240513 Series of 2025
            </p> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    goToApply() {
      window.open("https://apply.surf2sawa.com/", "_blank");
    },
  },
};
</script>

<style scoped>
.full-page-header {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.header-img-container {
  max-width: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-img-container img {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: -100px;
}

@media (max-width: 992px) {
  .full-page-header {
    min-height: auto;
    padding: 2rem 0;
  }

  .header-img-container img {
    width: 100%;
    max-width: 100%;
    margin-top: 0;
  }
}
</style>
